import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LotBynumOpe } from "src/app/models/LotBynumOpe";
import { lotDetails } from "src/app/models/LotDetails";
import { SearchOpeCriteria } from "src/app/models/SearchOpeCriteria";
import { docBisUrl } from "src/app/models/docsBiUrl";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class BienService{

    BASE_PATH_BI_PLAN = "/programmes-lots/bi-doc/";
    BASE_PATH_PLAN ="/plan";
    BASE_PATH_PLAN_DOCS ="/docs/bi-doc/";

    BASE_PATH_BI_GRILLE ="/programmes-lots/bi_v/bi-grille/"
    BASE_PATH_BI_DETAILS="/programmes-lots/bi_v/bi-detail/"
    constructor(private readonly http: HttpClient) {}

    getPlanBiBynumOpe(data: number): Observable<docBisUrl>{
      
      const url = environment.host.domaine;
      return this.http.get<docBisUrl>(url+this.BASE_PATH_PLAN_DOCS+data+this.BASE_PATH_PLAN);

      }

      
  public ToHttpParams(request: any |null | undefined, page: number, size: number): HttpParams {

    let httpParams = new HttpParams();
    httpParams = httpParams.append("page", page);
    httpParams = httpParams.append("size", size);
    if (request !== undefined && request !== null) {
      Object.keys(request).forEach((key) => {

      if (request[key]) {

        httpParams = httpParams.append(key, request[key]);
      }
    });
  }

    return httpParams;

  }
      getListBienbynumOpe(numOpe: number, filter: SearchOpeCriteria): Observable<LotBynumOpe[]>{

        const url = `${environment.host.domaine+this.BASE_PATH_BI_GRILLE+numOpe}?`
        return this.http.get<LotBynumOpe[]>(url, { params: this.ToHttpParams(filter, 0, 500) })
        
      }


      getDetailsLotBynumBie(numBien: number): Observable<lotDetails>{
        // https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8182/bi_v/bi-detail/511135

        const url = environment.host.domaine+this.BASE_PATH_BI_DETAILS  ;
        return this.http.get<lotDetails>(url+numBien);
      }
  }
